import React from 'react';
import {Button, Row} from 'reactstrap';
import {Panel} from "primereact/panel";
import DataTable from "../../../shared/component/dataTable/DataTable";
import ExternalSubcategoryMapColumn from "../../../shared/component/dataTable/columns/ExternalSubcategoryMapColumn.json";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import Translate from "../../../shared/language/Translate";
import Dialog from "../../../shared/component/dialog/Dialog";
import {PAGE_MODE} from "../../../shared/utils/Constants";
import {AvForm} from "availity-reactstrap-validation";
import ExternalSubcategoryMapSave from "./ExternalSubcategoryMapSave";
import ExternalSubcategoryMapService from "../../../shared/service/ExternalSubcategoryMapService";


class ExternalSubcategoryMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageMode: null
        };
        this.service = new ExternalSubcategoryMapService();
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Panel header="Dış Sistem Alt Kategori Eşleştirmeleri" style={{width: '75%'}}>
                    <Toolbar display={true}>
                        <div className="p-toolbar-group-right">
                            <Button color="primary" onClick={this.addNew}>
                                <Translate contentKey="entity.action.add">Yeni Kayıt</Translate>
                            </Button>
                        </div>
                    </Toolbar>

                    <DataTable ref={(elem) => this.refDataTable = elem} fields={ExternalSubcategoryMapColumn.fields} dataURL="externalSubcategoryMap/findAll"
                               privilege="allow"
                               selectionMode="single" onDataSelect={this.onDataSelect} export={true}/>

                    <Dialog visible={this.state.displayDialog}
                            header={GeneralUtils.getDialogHeader('Alt Kategori Eşleştirme', this.state.pageMode)}
                            onHide={() => this.setState({displayDialog: false})} style={{width: '50%'}}>
                        <AvForm onValidSubmit={this.save}>
                            <Toolbar
                                display={true}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" type="submit" className="float-right">
                                        <Translate contentKey="entity.action.save">Kaydet</Translate>
                                    </Button>
                                    <Button color="primary" className="float-right"
                                            onClick={() => this.setState({displayDialog: false})}>
                                        <Translate contentKey="entity.action.save">Vazgeç</Translate>
                                    </Button></div>

                            </Toolbar>
                            <ExternalSubcategoryMapSave ref={elem => this.refExternalSubcategoryMapSave = elem}/>
                        </AvForm>
                    </Dialog>
                </Panel>
            </Row>
        );
    }

    refresh = () => {
        this.refDataTable.refresh();
    }

    addNew = () => {
        this.setState({displayDialog: true, pageMode: PAGE_MODE.CREATE});
        this.refExternalSubcategoryMapSave.clearData();
    }

    onDataSelect = (data) => {
        let pageMode = GeneralUtils.getPageModeFromPrivilege(ExternalSubcategoryMapColumn.name);
        this.setState({displayDialog: true, pageMode: pageMode});
        this.refExternalSubcategoryMapSave.clearData();
        this.refExternalSubcategoryMapSave.setData(Object.assign({}, data), pageMode);
    }

    save = () => {
        let externalSubcategoryMap = this.refExternalSubcategoryMapSave.getData();
        if (!GeneralUtils.isNullOrEmpty(externalSubcategoryMap.id)) {
            this.service.update(externalSubcategoryMap).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({displayDialog: false});
                    this.refresh();
                }
            });
        } else {
            this.service.create(externalSubcategoryMap).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({displayDialog: false});
                    this.refresh();
                }
            });
        }
    }
}


export default ExternalSubcategoryMap;
